module.exports = __webpack_public_path__ + "static/media/radius02.8c5d18db.PNG";